module.exports = __webpack_public_path__ + "img/logo.33685a5.png";